import React, { useEffect, useState } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import {createCustomTheme} from "./theme";
import useFetchCustomTheme from "./hooks/useFetchCustomTheme";

const RootComponent = () => {
	const params = new URLSearchParams(window.location.search);
	const accommodation = params.get('lid');
	const { theme: customTheme, loadedFontNames, loading } = useFetchCustomTheme(accommodation);
	const [theme, setTheme] = useState(createCustomTheme());
	useEffect(() => {
		if (!loading && customTheme) {
			setTheme(createCustomTheme(customTheme, loadedFontNames));
		}
	}, [customTheme, loading, loadedFontNames]);
	
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<App />
		</ThemeProvider>
	);
};


export default RootComponent;
